import type { SpaceSlug } from '@toolproof-core/visualization/_contract/key';
import type { SpaceOverlayModel } from '@toolproof-core/visualization/runtime/_contract/overlay';

import {
    getSpaceSelectOptions,
} from '@/adapters/_@shared/spaceAdapterRegistry';

export const SPACE_NAVIGATION_SECTION_ID = 'space-navigation';

export function withSpaceNavigationOverlay(args: {
    activeSpaceSlug: SpaceSlug;
    overlayModel: SpaceOverlayModel | undefined;
}): SpaceOverlayModel {
    const section = {
        sectionKind: 'select' as const,
        sectionId: SPACE_NAVIGATION_SECTION_ID,
        label: 'Space',
        allowDuringPlayback: true,
        selectedValue: args.activeSpaceSlug,
        options: getSpaceSelectOptions(args.activeSpaceSlug).map((option) => ({
            value: option.spaceSlug,
            label: option.label,
        })),
    };
    return args.overlayModel === undefined
        ? {
            overlayId: `space-${args.activeSpaceSlug}`,
            title: section.label,
            sections: [section],
        }
        : {
            ...args.overlayModel,
            sections: [section, ...args.overlayModel.sections],
        };
}